import { render } from "./BuyCreditPopup.vue?vue&type=template&id=5a9601c9&scoped=true"
import script from "./BuyCreditPopup.vue?vue&type=script&lang=js"
export * from "./BuyCreditPopup.vue?vue&type=script&lang=js"

import "./BuyCreditPopup.vue?vue&type=style&index=0&id=5a9601c9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9601c9"]])

export default __exports__